// extracted by mini-css-extract-plugin
export var cardLayout = "_7b-1";
export var paginationContainer = "_7b-0";